export default "__VITE_ASSET__Drn9Kjsv__"